import React, { useState, useContext } from 'react'
import axios from 'axios'

// Material UI
import { Button } from '@material-ui/core'
import Box from '@material-ui/core/Box'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import CardHeader from '@material-ui/core/CardHeader'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

// Icons
import CreditCardIcon from '@material-ui/icons/CreditCard'

import {
  Context,
  SquarePaymentForm,
  CreditCardCVVInput,
  CreditCardExpirationDateInput,
  CreditCardNumberInput,
  CreditCardPostalCodeInput,
} from 'react-square-payment-form'

import 'react-square-payment-form/lib/default.css'
import './SquarePayment.css'


// Style
import { makeStyles } from '@material-ui/core/styles'

// Translation
import { Language } from '../../Translation'

// Store Context
import { StoreContext } from '../../context/StoreContext'

const APPLICATION_ID = 'sandbox-sq0idb-Kscd-fYExCDLoqBo5AnYow'
const LOCATION_ID = 'DXD279YVS2YTG'

const useStyles = makeStyles((theme) => ({
  card: {
    background: "white",
    cursor: "pointer",
    marginTop: 15,
    marginBottom: 15,
    marginLeft: 15,
    marginRight: 15,
  },
  footer: {
    backgroundColor: "#f5f5f5",
    position: "fixed",
    width: "100%",
    bottom: -35,
    zIndex: 1,
  },
  continueButton: {
    width: "100%",
    backgroundColor: "#003366",
  }
}));

const SquarePayment = ({ subTotal, taxes, tips, total }) => {

  const [errorMessages, setErrorMessages] = useState([])
  const paymentInfo = { Amount: Math.round(total * 100), Nonce: '' }

  const appContext = useContext(StoreContext)
  const { language } = appContext

  const styles = { alignItems: "baseline" }
  const classes = useStyles()

  function cardNonceResponseReceived(errors, nonce, cardData, buyerVerificationToken) {

    if (errors[0] !== null) {
      setErrorMessages(errors.map(error => error.message));
      return;
    }

    paymentInfo.Nonce = nonce

    setErrorMessages([]);

    console.log(paymentInfo)

    //https://cors-anywhere.herokuapp.com/http://onlineo.ddns.net:8080/OO3/squarePayment/index.php

    axios.post('http://tamio.test/square/index.php', paymentInfo)

      .then((response) => {

        console.log(response.data)

      }, (error) => {

        console.log(error)
      });

    //alert('nonce created: ' + nonce + ', buyerVerificationToken: ' + buyerVerificationToken);
    // API.post('/payments', data: { nonce: nonce, buyerVerificationToken: buyerVerificationToken }) // implement this
  }

  const SubmitButton = () => {

    const context = useContext(Context)

    const handleSubmit = evt => {
      evt.preventDefault()
      context.onCreateNonce()
    }

    console.log(tips)

    return (
      <>
        <Card className={classes.footer}>
          <CardContent>
            <Typography variant="h6">
              <Grid justify="space-between" container style={styles}>
                <Grid item>
                  <Box>{Language.PaymentPageSubTotal[language]}</Box>
                </Grid>
                <Grid item>
                  {subTotal.toFixed(2)}$
                    </Grid>
              </Grid>
              <Grid justify="space-between" container style={styles}>
                <Grid item>
                  <Box>{Language.PaymentPageTax[language]}</Box>
                </Grid>
                <Grid item>
                  {taxes.toFixed(2)}$
                    </Grid>
              </Grid>
              {tips !== 0 &&
                <Grid justify="space-between" container style={styles}>
                  <Grid item>
                    <Box>Tips:</Box>
                  </Grid>
                  <Grid item>
                    {(+tips).toFixed(2)}$
                    </Grid>
                </Grid>
              }
              <Grid justify="space-between" container style={styles}>
                <Grid item>
                  <Box fontWeight="fontWeightBold">{Language.PaymentPageTotal[language]}</Box>
                </Grid>
                <Grid item>
                  <Box fontWeight="fontWeightBold">{total.toFixed(2)}$</Box>
                </Grid>
              </Grid>
            </Typography>
            <Button className={classes.continueButton} onClick={handleSubmit} variant="contained" size="large" >
              <Typography style={{ color: "white" }}>{Language.PaymentPagePayButton[language]} : {total.toFixed(2)}$</Typography>
            </Button>
            <br />
            <br />
          </CardContent>
        </Card>
      </>
    );
  }

  function createVerificationDetails() {
    return {
      amount: '1000.00',
      currencyCode: 'CAD',
      countryCode: 'CAD',
      intent: 'CHARGE',
      billingContact: {
        familyName: 'Smith',
        givenName: 'John',
        email: 'jsmith@example.com',
        country: 'CA',
        city: 'London',
        addressLines: ["1235 Emperor's Gate"],
        postalCode: 'SW7 4JA',
        phone: '020 7946 0532',
      },
    };
  }

  return (
    <>
      <SquarePaymentForm
        sandbox={true}
        applicationId={APPLICATION_ID}
        locationId={LOCATION_ID}
        placeholderPostal={'A1A 1A1'}
        cardNonceResponseReceived={cardNonceResponseReceived}
        createVerificationDetails={createVerificationDetails}
      >

        <Card className={classes.card}>
          <CardHeader
            avatar={
              <CreditCardIcon />
            }
            title="Credit Card Informations"
          />
          <CardContent>

            <fieldset className="sq-fieldset">

              <CreditCardNumberInput />

              <div className="sq-form-third">
                <CreditCardExpirationDateInput />
              </div>

              <div className="sq-form-third">
                <CreditCardPostalCodeInput />
              </div>

              <div className="sq-form-third">
                <CreditCardCVVInput />
              </div>

            </fieldset>

            <div className="sq-error-message">
              {errorMessages.map(errorMessage => (
                <li key={`sq-error-${errorMessage}`}>{errorMessage}</li>
              ))}

            </div>

          </CardContent>
        </Card>

        <SubmitButton />

      </SquarePaymentForm >
    </>
  );
};

export default SquarePayment;